import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import './Objectives.css';

const Objectives = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const objectives = [
    t.objective1,
    t.objective2,
    t.objective3,
    t.objective4,
    t.objective5
  ];

  return (
    <section className="section section-alt">
      <div className="container">
        <div className="objectives-content">
          <h2>{t.strategicObjectives}</h2>
          <p className="objectives-intro">{t.objectivesIntro}</p>
          
          <div className="objectives-list">
            {objectives.map((objective, index) => (
              <div key={index} className="objective-item">
                <div className="objective-number">{index + 1}</div>
                <p>{objective}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Objectives;